module.exports = __webpack_public_path__ + "style/img/Group 2258(2).92d524b0.png";